<template>
	<div class="my_topic">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">先进集体评奖区级管理——设置专家评审</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="topic_list" v-if="topicList.length">
											<div class="topic_item" v-for="item in topicList" :key="item.id">
												<div class="item_body">
													<div style="text-align: center;font-size: 22px;">{{ $route.query.name }}</div>
													<div class="expRevSchedule">
														<div class="progress pro-expertReview">
															<div
																class="progress-bar progress-bar-striped progress-bar-animated bg-success"
																:style="scheduleList[scheduleActive - 1].style"
															></div>
															<div
																class="proPoint"
																:class="{
																	active: scheduleActive >= item.id,
																	['proPoint' + item.id]: true,
																	'cur-active': curShowProgress == item.id
																}"
																v-for="item in scheduleList"
																:key="item.id"
																@click="handleScheduleChange(item.id)"
															>
																<a v-if="item.id == 5">
																	<el-popconfirm
																		title="开启专家评分后，评审设置不允许再修改，确定要开启吗？"
																		@confirm="submitProcess"
																		v-if="scheduleActive < 5"
																	>
																		<a slot="reference">
																			<i>{{ item.id }}</i>
																			{{ item.name }}
																		</a>
																	</el-popconfirm>
																	<a slot="reference" v-else>
																		<i>{{ item.id }}</i>
																		{{ item.name }}
																	</a>
																</a>
																<a v-if="item.id == 8">
																	<el-popconfirm title="确定结束评审？" @confirm="isEndEduProject">
																		<a slot="reference">
																			<i>{{ item.id }}</i>
																			{{ item.name }}
																		</a>
																	</el-popconfirm>
																</a>
																<a v-if="item.id !== 8 && item.id !== 5">
																	<i>{{ item.id }}</i>
																	{{ item.name }}
																</a>
															</div>
														</div>
													</div>
													<!-- 评价基本信息 -->
													<div class="essential" v-if="curShowProgress == 1">
														<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
															<el-form-item label="活动名称" prop="name"><el-input disabled v-model="ruleForm.name"></el-input></el-form-item>
															<el-form-item label="评审方式" prop="reviewWay">
																<el-radio v-model="ruleForm.reviewWay" :label="0">匿名</el-radio>
																<el-radio v-model="ruleForm.reviewWay" :label="1">非匿名</el-radio>
															</el-form-item>
															<el-form-item label="评语" prop="evaluationWay">
																<el-radio v-model="ruleForm.evaluationWay" :label="0">不必填</el-radio>
																<el-radio v-model="ruleForm.evaluationWay" :label="1">必填</el-radio>
															</el-form-item>
															<el-form-item label="评审截止日期" prop="reviewEndTime">
																<el-date-picker
																	v-model="ruleForm.reviewEndTime"
																	type="datetime"
																	value-format="yyyy-MM-dd HH:mm:ss"
																	placeholder="选择日期"
																></el-date-picker>
															</el-form-item>
														</el-form>
														<el-button type="primary" v-if="firstFlow == 1 && isShow" @click="submitForm('ruleForm')">保存并下一步</el-button>
														<el-button type="primary" v-if="firstFlow !== 1 && firstFlow < 5" @click="submitForm('ruleForm')">保存</el-button>
													</div>

													<!-- 评审分组 -->
													<reviewGroup v-if="curShowProgress == 2" @finishBtn="finishBtn" />

													<!-- 分配专家 -->
													<assignExperts v-if="curShowProgress == 3" @finishBtn="finishBtn" />

													<!-- 设置评分 -->
													<scoringCriteria v-if="curShowProgress == 4" :groupId="auditInformate.groupId" @finishBtn="finishBtn" />

													<!-- 开启评审打分 -->
													<div v-if="curShowProgress == 5" style="text-align: center;">已开启评审打分</div>

													<!-- 查看评审 -->
													<viewReview v-if="curShowProgress == 6" />

													<!-- 评审结果 -->
													<reviewResults v-if="curShowProgress == 7" />

													<!-- 评审结束 -->
													<div v-if="scheduleActive == 8 && curShowProgress == 8" style="text-align: center;">专家评审已经结束！</div>
												</div>
											</div>
										</div>
										<!-- 无数据处理 -->
										<div class="no_data" v-else>暂无数据</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import reviewResults from './components/reviewResults.vue';
import viewReview from './components/viewReview.vue';
import scoringCriteria from './components/scoringCriteria.vue';
import assignExperts from './components/assignExperts.vue';
import reviewGroup from './components/reviewGroup.vue';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import TopicProgress from './components/TopicProgress';
import { getTopicListByUser } from '@/api/after/topicManage.js';
import { getReviewInfo, saveBasicInfo, saveOrUpdate, endEduProject } from '@/api/after/newInterface.js';
export default {
	components: {
		Breadcrumb,
		TopicProgress,
		reviewGroup,
		assignExperts,
		scoringCriteria,
		viewReview,
		reviewResults
	},
	data() {
		return {
			scheduleActive: 1, //当前进度条
			curShowProgress: 1, //当前显示进度
			scheduleList: [
				{ id: 1, name: '评价基本信息', style: 'width:0%;' },
				{ id: 2, name: '评审分组', style: 'width:14.28%;' },
				{ id: 3, name: '分配专家', style: 'width:28.56%;' },
				{ id: 4, name: '设置评分标准', style: 'width:42.84%;' },
				{ id: 5, name: '开启评审打分', style: 'width:57.12%;' },
				{ id: 6, name: '查看评审进度', style: 'width:71.4%;' },
				{ id: 7, name: '查看评审结果', style: 'width:85.68%;' },
				{ id: 8, name: '结束', style: 'width:100%;' }
			],
			topicListQuery: {
				//课题列表参数
				pageNumber: 1,
				pageSize: 20
			},
			// 审核信息
			auditInformate: {
				flow: 0
			},
			// 课题列表
			topicList: [
				{
					coreMember: '周丽晶,吕琼,王舒媛,林珮鑫',
					coreMemberName: null,
					createTime: '2022-08-06 16:05:39',
					declareId: 91,
					declareName: '青年教师与家长沟通的方式途径与技巧的研究',
					status: 2
				}
			],
			topicListTotal: 0,
			ruleForm: {
				name: '',
				reviewWay: 1,
				evaluationWay: '',
				reviewEndTime: '',
				projectId: ''
			},
			rules: {
				name: [{ required: true, message: '请输入评审名称', trigger: 'blur' }],
				reviewWay: [{ required: true, message: '请选择评审方式', trigger: 'blur' }],
				evaluationWay: [{ required: true, message: '请选择评语', trigger: 'blur' }],
				reviewEndTime: [{ required: true, message: '请选择评审截止日', trigger: 'blur' }]
			},
			isDis: false,
			flow: 0,
			isDisable: true,
			isShow: true,
			firstFlow: 1
		};
	},
	computed: {
		getTimeRange(val1, val2) {
			return (val1, val2) => {
				if (val1) {
					return val1.slice(0, 7) + ' ~ ' + val2.slice(0, 7);
				}
			};
		}
	},
	created() {
		this.ruleForm.name = this.$route.query.name;
		this.ruleForm.projectId = this.$route.query.id;
		sessionStorage.setItem('projectId', this.ruleForm.projectId);
		this.getCurrentInfo();
	},
	methods: {
		//结束征文
		isEndEduProject() {
			endEduProject({ flow: 8, id: this.ruleForm.projectId }).then(res => {
				if (res.code == 200) {
					saveOrUpdate({ flow: 8, id: this.ruleForm.projectId }).then(res => {
						if (!res.code == 200) {
							this.$message.error(res.data);
						} else {
							this.$message.success(res.msg);
							this.$router.go(-1);
						}
					});
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 点击进度改变
		handleScheduleChange(index) {
			if (index == 1) {
				getReviewInfo(this.ruleForm.projectId).then(res => {
					if (res.code == 200) {
						if (res.data.flow < 5) {
							this.isShow = true;
							this.firstFlow = res.data.flow;
						} else {
							this.isShow = false;
							this.firstFlow = res.data.flow;
						}
					}
				});
			}
			this.curShowProgress = index;
		},
		finishBtn(flow) {
			this.editProcess(flow);
		},
		submitProcess() {
			getReviewInfo(this.ruleForm.projectId).then(res => {
				if (res.code == 200) {
					this.finishBtn(7);
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		submitForm(formName) {
			this.$refs[formName][0].validate(valid => {
				if (valid) {
					saveBasicInfo(this.ruleForm).then(res => {
						if (res.code !== 200) {
							this.$message.error(res.data);
						} else {
							this.$message.success(res.msg);
							if (this.firstFlow == 1) {
								this.finishBtn(2);
								this.editProcess(2);
							}
						}
					});
				} else {
					return false;
				}
			});
		},
		editProcess(flow) {
			saveOrUpdate({ flow, id: this.ruleForm.projectId }).then(res => {
				if (!res.code == 200) {
					this.$message.error(res.data);
				} else {
					this.scheduleActive = flow;
					this.curShowProgress = flow;
					getReviewInfo(this.ruleForm.projectId).then(res => {
						this.scheduleActive = res.data.flow;
					});
				}
			});
		},
		//当前信息
		getCurrentInfo() {
			getReviewInfo(this.ruleForm.projectId).then(res => {
				if (res.code == 200) {
					this.auditInformate = res.data;
					this.goProgressByReviewState(res.data.flow)
					if (res.data.eduExpertsSubjectGroup) {
						this.ruleForm.reviewWay = res.data.eduExpertsSubjectGroup.reviewWay;
						this.ruleForm.evaluationWay = res.data.eduExpertsSubjectGroup.evaluationWay;
						this.ruleForm.reviewEndTime = res.data.eduExpertsSubjectGroup.reviewEndTime;
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 根据评审状态跳转进程
		goProgressByReviewState(flow) {
			switch (flow) {
				case 1:
					this.scheduleActive = 1;
					this.curShowProgress = 1;
					break;
				case 2:
					this.scheduleActive = 2;
					this.curShowProgress = 2;
					break;
				case 3:
					this.scheduleActive = 3;
					this.curShowProgress = 3;
					break;
				case 4:
					this.scheduleActive = 4;
					this.curShowProgress = 4;
					break;
				case 6:
					this.scheduleActive = 6;
					this.curShowProgress = 6;
					break;
				case 7:
					this.scheduleActive = 7;
					this.curShowProgress = 7;
					break;
				case 8:
					this.scheduleActive = 8;
					this.curShowProgress = 8;
					break;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
	margin-left: 10px;
}
.button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
}
.input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
}
.input-new-unit {
	width: 160px;
	margin-left: 10px;
	vertical-align: bottom;
}

.no_data {
	min-height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.topic_progress_wrap {
	display: flex;
	align-items: center;
}
.progress_custom {
	flex: 1;
}
.topic_item {
	margin-bottom: 20px;
}
.item_title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #eee;
	height: 50px;
	.topic_level {
		font-weight: bolder;
	}
	.topic_title {
		font-size: 16px;
		max-width: 300px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.topic_title_wrap {
		display: flex;
		align-items: center;
	}
}

.process_materials_title,
.change_request_title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 10px 0;
}
.btn_wrap {
	margin-top: 10px;
}
.custom_table {
	height: 40px;
	line-height: 40px;
	text-align: center;
	background-color: #d0e4f5;
	color: #2d87bd;
}
.upload_change_topic_info_form {
	::v-deep .el-form-item {
		margin-bottom: 0;
	}
	::v-deep .el-row {
		display: flex;
		align-items: center;
		padding: 10px 0;
		border: 1px solid #dfedfc;
	}
	::v-deep .el-row:first-child {
		padding: 0 !important;
	}
	.form_item_title {
		display: inline-block;
		width: 130px;
		padding-right: 10px;
		text-align: right;
	}
	.tip {
		color: red;
	}
}
.proPoint.cur-active i {
	background-color: #0080c0;
	color: #fff;
}
</style>
